import { useState } from 'react'
import { formatDay } from '../patientFormat'
import { formatClock, painClass, toleranceLabel } from './therapyFormat'

function TherapyHistory({ sessions }) {
  const [openId, setOpenId] = useState(null)

  return (
    <section className="therapy-block" data-onboarding="therapy-history">
      <div className="patients-section-head">
        <div>
          <h3>Histórico de evolução</h3>
          <p className="patients-muted">Sessões registradas, da mais recente para a mais antiga.</p>
        </div>
      </div>
      {sessions.length === 0 && <p className="patients-muted">Nenhuma sessão registrada.</p>}
      <ol className="therapy-timeline">
        {sessions.map((session) => {
          const done = (session.items || []).filter((item) => item.completed).length
          const total = (session.items || []).length
          const open = openId === session.id
          const clock = formatClock(session.session_time)
          return (
            <li key={session.id}>
              <button type="button" className="therapy-timeline-item" onClick={() => setOpenId(open ? null : session.id)}>
                <span className={`therapy-pain-badge ${painClass(session.pain_score)}`}>{session.pain_score}</span>
                <span className="therapy-timeline-copy">
                  <strong>{formatDay(session.session_date)}{clock ? ` às ${clock}` : ''}</strong>
                  <small>
                    {session.author_name || 'Profissional'}
                    {' · '}
                    {toleranceLabel(session.tolerance)}
                    {session.pain_location ? ` · ${session.pain_location}` : ''}
                    {total ? ` · ${done}/${total} atividades` : ''}
                  </small>
                </span>
              </button>
              {open && (
                <div className="therapy-timeline-detail">
                  {session.notes && <p>{session.notes}</p>}
                  {(session.items || []).length === 0 && <p className="patients-muted">Sessão sem checklist.</p>}
                  <ul>
                    {(session.items || []).map((item) => (
                      <li key={item.id}>
                        <strong>{item.completed ? 'Fez' : 'Não fez'}</strong>
                        {' '}
                        {item.activity_title}
                        {(item.sets_done != null || item.repetitions_done != null) && (
                          <span>
                            {' · '}
                            {item.sets_done != null ? `${item.sets_done} séries` : 'séries não informadas'}
                            {item.repetitions_done != null ? ` · ${item.repetitions_done} repetições` : ''}
                          </span>
                        )}
                        {item.notes && <span> · {item.notes}</span>}
                      </li>
                    ))}
                  </ul>
                </div>
              )}
            </li>
          )
        })}
      </ol>
    </section>
  )
}

export default TherapyHistory
